const FeInvoices = () => import("Modules/sales/fe_invoices/views/FeInvoices");
const FeInvoicesForm = () => import("Modules/sales/fe_invoices/views/FeInvoicesForm");

export default {
    children: [
        {
            path: "sales/fe_invoices",
            name: "fe_invoices",
            component: FeInvoices,
            meta: {
                requiresAuth: true,
                title: "lang.fe_invoices",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["fe_invoices.read"],
            },
        },
        {
            path: "sales/fe_invoice/:id?",
            name: "fe_invoice",
            component: FeInvoicesForm,
            meta: {
                requiresAuth: true,
                title: "lang.fe_invoices",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["fe_invoices.read"],
            },
        },
    ],
};
